<!-- src/app/pages/cost-metrics/costing-data/costing-data.component.html -->
<div class="tabHeading">
    <h3 class="mb-0">Costmetrics Data</h3>
</div>
<div class="rounded-2xl max-w-2xl p-4">
    <!-- Group dropdown (header style) -->
    <div class="mb-6">
        <p-select [options]="groups" [(ngModel)]="group" optionLabel="label" optionValue="value" styleClass="w-full rounded-xl border bg-gradient-to-b f12 from-slate-50 to-white" placeholder="Select group"> </p-select>
    </div>

    <!-- Items list -->
    <div class="space-y-6">
        @for (it of items; track trackById($index, it)) {
        <div class="flex items-center justify-between gap-6">
            <div class="f12 leading-snug">{{ it.label }}</div>
            <input pInputText class="w-36 f12 text-right font-medium" [ngModel]="format(it.value)" (ngModelChange)="onEdit(it.id, $event)" inputmode="numeric" [attr.aria-label]="it.label + ' cost'" />
        </div>
        }
    </div>
</div>
